import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTelegram = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcTelegram"
}), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "20",
  fill: "#4BB5F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.64987 19.1794C15.0923 16.498 19.3883 14.7303 21.5378 13.8763C27.675 11.4377 28.9503 11.0141 29.7815 11.0001C29.9643 10.9971 30.3731 11.0404 30.6379 11.2456C30.8614 11.4189 30.9229 11.653 30.9524 11.8173C30.9818 11.9816 31.0185 12.3559 30.9893 12.6484C30.6568 15.9865 29.2177 24.0874 28.4856 27.8262C28.1758 29.4082 27.5658 29.9387 26.9753 29.9906C25.6919 30.1034 24.7174 29.1804 23.4744 28.402C21.5294 27.184 20.4305 26.4259 18.5425 25.2373C16.3606 23.8638 17.7751 23.1089 19.0185 21.8751C19.344 21.5522 24.9985 16.6391 25.1079 16.1933C25.1216 16.1376 25.1343 15.9298 25.0051 15.8201C24.8759 15.7104 24.6851 15.7479 24.5475 15.7777C24.3524 15.82 21.2452 17.782 15.2258 21.6635C14.3439 22.242 13.545 22.5239 12.8292 22.5091C12.0402 22.4929 10.5223 22.083 9.39397 21.7326C8.00999 21.3028 6.91003 21.0756 7.00581 20.3457C7.0557 19.9656 7.60372 19.5768 8.64987 19.1794Z",
  fill: "white"
}));
export { IconIcTelegram as default };
//# sourceMappingURL=IconIcTelegram.js.map